import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";

import UrgencyTag from "../urgencies/UrgencyTag";
import { Priority } from "../priorities/Priority";
import { fetchPriorities, updatePriority } from "../priorities/proritiesApi";
import NoResultsFound from "../../common/components/noResultsFound/NoResultsFound";
import LoadingSpinner from "../../common/components/loadingSpinner/LoadingSpinner";

interface PrioritiesTableProps {
  departmentId: string;
}

export default function PrioritiesTable({ departmentId }: PrioritiesTableProps) {
  const [priorities, setPriorities] = useState<Priority[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    doFetchPriorities();
  }, [departmentId]);

  const doFetchPriorities = async () => {
    if (departmentId) {
      const priorities = await fetchPriorities(departmentId);
      setPriorities(priorities);
      setIsLoading(false);
    }
  };

  const onRowEditComplete = async (event: DataTableRowEditCompleteEvent) => {
    if (!event.newData.slaMinutes) {
      toast.error("SLA trebuie să fie un numar mai mare decat 0");
      return;
    }

    setIsLoading(true);
    const updatedPriority: Priority = {
      departmentId: event.newData.departmentId,
      urgency: event.newData.urgency,
      businessImpact: event.newData.urgency,
      ticketPriority: event.newData.urgency,
      slaMinutes: event.newData.slaMinutes,
    };

    const _priorities = [...priorities];
    _priorities[event.index] = updatedPriority;
    setPriorities(_priorities);

    await updatePriority(updatedPriority);
    await doFetchPriorities();
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <Card title="Configurare SLA">
      <DataTable size="small" editMode="row" value={priorities} onRowEditComplete={onRowEditComplete} emptyMessage={<NoResultsFound />}>
        <Column
          className="w-9rem"
          field="urgency"
          header="Prioritate"
          body={(rowData: Priority) => <UrgencyTag className="h-2rem" value={rowData.urgency}></UrgencyTag>}
        ></Column>
        <Column
          className="w-13rem"
          field="slaMinutes"
          header="Minute working hours"
          body={(rowData: Priority) => (
            <InputNumber className="p-inputtext-sm w-full" size={5} useGrouping={false} value={rowData.slaMinutes} disabled />
          )}
          editor={(options) => (
            <InputNumber
              className="p-inputtext-sm w-full"
              size={5}
              max={262800}
              useGrouping={false}
              value={options.value}
              onChange={(e) => options.editorCallback?.(e.value)}
            />
          )}
        ></Column>
        <Column className="text-right" rowEditor />
      </DataTable>
    </Card>
  );
}
